module.exports = __webpack_public_path__ + "img/f38266e.png";